import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

export const Footer = () => (
  <footer className="bg-slate-900 text-slate-400 mt-24">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
      <div>
        <div className="flex items-center gap-2 mb-4">
          <Compass className="w-5 h-5 text-emerald-500" />
          <span className="font-heading font-semibold text-white">SocialFlats</span>
        </div>
        <p className="text-sm leading-relaxed max-w-xs">
          Social Flats is your exclusive gateway to the affiliate network — free access, ready-made ads and up to 21% commission per click value.
        </p>
      </div>
      <div>
        <p className="uppercase text-xs tracking-[0.2em] font-semibold text-slate-500 mb-4">Explore</p>
        <ul className="space-y-2 text-sm">
          <li><Link to="/programs" className="hover:text-white transition-colors duration-200">Program Directory</Link></li>
          <li><Link to="/rewards" className="hover:text-white transition-colors duration-200">Rewards & Tiers</Link></li>
          <li><Link to="/niches" className="hover:text-white transition-colors duration-200">Niche Explorer</Link></li>
          <li><Link to="/compare" className="hover:text-white transition-colors duration-200">Comparison Tool</Link></li>
          <li><Link to="/calculators" className="hover:text-white transition-colors duration-200">Calculators</Link></li>
          <li><Link to="/beginners" className="hover:text-white transition-colors duration-200">Beginner's Hub</Link></li>
          <li><Link to="/about" className="hover:text-white transition-colors duration-200">About & Contact</Link></li>
          <li><Link to="/get-featured" className="hover:text-white transition-colors duration-200">Get Featured ($49)</Link></li>
        </ul>
      </div>
      <div>
        <p className="uppercase text-xs tracking-[0.2em] font-semibold text-slate-500 mb-4">Disclosure</p>
        <p className="text-sm leading-relaxed">
          This site may contain affiliate links. We may earn a commission when you join programs through our links, at no cost to you. Data is researched and updated periodically — always verify terms on the program's official page.
        </p>
      </div>
    </div>
    <div className="border-t border-slate-800 py-6 px-4 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6 text-xs text-slate-600">
      <span>© {new Date().getFullYear()} Social Affiliates LLC, operating as Social Flats. All rights reserved.</span>
      <Link to="/admin" data-testid="footer-admin-login-link" className="hover:text-slate-300 transition-colors duration-200 underline underline-offset-2">Admin Login</Link>
    </div>
  </footer>
);
